<template>
  <section class="saved-ranges-selector">
    <div
      v-for="(visibleSavedRange) in visibleSavedRanges"
      v-bind:key="visibleSavedRange.id"
      v-bind:class="'level-' + visibleSavedRange.level + ' indexes-' + visibleSavedRange.indexes.toString().replace(/,/g, '-')"
    >
      <div class="radio">
       
        <span
          v-if="visibleSavedRange.children"
          class="glyphicon"
          v-bind:class="{
            'glyphicon-triangle-bottom': !visibleSavedRange.collapsed,
            'glyphicon-triangle-right': visibleSavedRange.collapsed
          }"
          v-on:click="toggleCollapse(visibleSavedRange)"
        ></span>

        <label v-if="!visibleSavedRange.children" v-bind:class="{ disabled: disabled }">
          <input
            type="radio"
            value=""
            v-bind:disabled="disabled"
            v-bind:checked="visibleSavedRange.checked"
            v-on:change="setRangeToMatchGeneralHands(visibleSavedRange, $event)"
          >
          <!-- v-bind:checked="doesRangeExactlyEqualSavedRange(visibleSavedRange)" -->

          {{ visibleSavedRange.name }}
        </label>
        <span
          v-else
          v-on:click="toggleCollapse(visibleSavedRange)"
        >{{ visibleSavedRange.name }}</span>
      </div>
    </div>
    <hr>
    <p v-if="loggedIn" class="customize"><router-link to="/settings/general/saved-ranges"><small>Customize saved ranges</small></router-link></p>
  </section>
</template>

<script>
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  name: 'saved-ranges-selector',
  props: ['generalHands', 'disabled'],
  data: function () {
    let savedRanges = _.cloneDeep(this.$store.state.account.user.settings.general.savedRanges);

    utilities.general.forEachNode(savedRanges, function (node, indexes) {
      node.level = indexes.length - 1;
      node.indexes = indexes;
      node.checked = false;

      if (node.children) {
        node.collapsed = true;
      }
    });

    return {
      savedRanges: savedRanges,
    };
  },
  computed: {
    visibleSavedRanges: function () {
      let visibleSavedRanges = [];

      this.forEachVisibleNode(this.savedRanges, function (node, indexes) {
        node.id = _.uniqueId();
        visibleSavedRanges.push(node);
      });

      return visibleSavedRanges;
    },
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
  },
  created: function () {
    this.expandFirstVisibleNode();
  },
  methods: {
    forEachVisibleNode: function (arr, callback, indexesList) {
      indexesList = indexesList || [];

      arr.forEach(function (el, i) {
        let newIndexesList = _.cloneDeep(indexesList);
        newIndexesList.push(i);
        callback(el, newIndexesList);

        if (el.children && !el.collapsed) {
          this.forEachVisibleNode(el.children, callback, newIndexesList);
        }
      }, this);
    },
    doesRangeExactlyEqualSavedRange: function (savedRange) {
      let handStringsFromSavedRange = savedRange.handsInRange;
      let handStringsInRange = [];

      this.generalHands.forEach(function (generalHand) {
        if (generalHand.inRange === true) {
          handStringsInRange.push(generalHand.string);
        }
      });

      return utilities.general.doArraysContainSameElements(handStringsFromSavedRange, handStringsInRange);
    },
    setRangeToMatchGeneralHands: function (savedRange, e) {

      //SHOR-7: More than one radio button shown as selected
      for (let i = 0; i < this.visibleSavedRanges.length; i++) {

        let range = this.visibleSavedRanges[i]

        if (this.visibleSavedRanges[i].id === savedRange.id) {

          range.checked = true
          
        }else{
          range.checked = false
        }
         
      }      
      //SHOR-7


      this.$emit('setRangeToMatchGeneralHands', savedRange.handsInRange);
    },
    toggleCollapse: function (visibleSavedRange) {
      visibleSavedRange.collapsed = !visibleSavedRange.collapsed;
    },
    expandFirstVisibleNode: function () {
      for (let i = 0; i < this.visibleSavedRanges.length; i++) {
        if (this.visibleSavedRanges[i].children) {
          this.visibleSavedRanges[i].collapsed = false;
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .saved-ranges-selector {
    max-height: 350px;
    overflow-y: auto; // only appears when needed
  }

  input[type="radio"] {
    position: relative;
    margin-right: 3px;
    margin-left: -17px;
  }

  .radio:first-child {
    margin-top: 0px;
  }

  .level-1 { margin-left: 25px; }
  .level-2 { margin-left: 50px; }
  .level-3 { margin-left: 75px; }
  .level-4 { margin-left: 100px; }
  .level-5 { margin-left: 125px; }
  .level-6 { margin-left: 150px; }
  .level-7 { margin-left: 175px; }
  .level-8 { margin-left: 200px; }

  .radio span {
    cursor: pointer;
  }

  .radio label.disabled {
    cursor: not-allowed;
  }

  .glyphicon {
    color: lightgray;
    cursor: pointer;
    position: relative;
    top: 2px;
  }

  .customize a {
    color: #333;
  }

  @media (max-width: 475px) {
    .saved-ranges-selector {
      max-height: none;
    }

  }

  @media (max-device-width: 768px) {
    .radio {
      padding: 5px 0;

      .glyphicon {
        padding: 1em 1.5em;
      }

      input[type="radio"] {
        margin-left: -1px;
        margin-right: 18px;
      }
    }

    @media (min-width: 650px) {
      .radio:first-child {
        margin-top: 0;

        .glyphicon {
          padding-top: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/saved-ranges-selector.vue